<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1" />
        </section>

        <section class="dp-right five-star-publish-page">
            <div v-if="!schoolDepartmentId" class="no-dept-tip">
                <i class="el-icon-info"></i> 请在左侧选择学校
            </div>

            <template v-else>
                <div class="publish-page-content">
                <toolbar ref="listToolbar" :buttonList="buttonList" @callFunction="callFunction"
                    :searchList="searchList" />

                <div v-if="semesterBoard.campusName" class="board-campus-title">
                    {{ semesterBoard.campusName }}
                </div>

                <div v-loading="listLoading" class="publish-list-wrap">
                    <div v-if="campusListEmpty" class="campus-select-tip">
                        <i class="el-icon-info"></i> 该学校下暂无校区，请在机构树选择校区节点
                    </div>
                    <div v-else-if="needsCampusSelect" class="campus-select-tip">
                        <i class="el-icon-info"></i> 请在上方选择校区
                    </div>
                    <div v-else-if="!listLoading && !semesterBoardSemesters.length" class="publish-empty">
                        <el-empty description="暂无荣誉学期配置" />
                    </div>
                    <div v-else class="semester-board-layout">
                        <div class="semester-nav">
                            <div v-for="item in semesterBoardSemesters" :key="item.HonorSemesterId"
                                class="semester-nav-item"
                                :class="{ 'is-active': item.HonorSemesterId === activeSemesterId }"
                                @click="selectBoardSemester(item.HonorSemesterId)">
                                <div class="semester-nav-title">
                                    <span class="semester-nav-name">{{ item.HonorSemesterName }}</span>
                                    <el-tag v-if="item.IsCurrent == 1" size="mini" type="success" effect="plain">当前</el-tag>
                                </div>
                                <p v-if="item.HonorSemesterStartDate" class="semester-nav-range">
                                    {{ item.HonorSemesterStartDate }} ~ {{ item.HonorSemesterEndDate }}
                                </p>
                                <span class="semester-nav-meta">
                                    {{ getSemesterTotalClassCount(item) }} 个班
                                </span>
                            </div>
                        </div>
                        <div v-if="activeSemesterItem" class="semester-board-detail">
                            <div class="semester-board-head">
                                <div class="semester-board-head-main">
                                    <span class="semester-name">{{ activeSemesterItem.HonorSemesterName }}</span>
                                    <el-tag v-if="activeSemesterItem.IsCurrent == 1" size="mini" type="success"
                                        effect="plain" class="current-semester-tag">当前</el-tag>
                                    <p v-if="activeSemesterItem.HonorSemesterStartDate" class="semester-range">
                                        {{ activeSemesterItem.HonorSemesterStartDate }}
                                        ~ {{ activeSemesterItem.HonorSemesterEndDate }}
                                    </p>
                                </div>
                                <div v-if="activeSemesterItem.HasPublished" class="semester-board-head-meta">
                                    <span><i class="el-icon-time"></i> {{ activeSemesterItem.PublishedAt }}</span>
                                    <span><i class="el-icon-user"></i>
                                        {{ activeSemesterItem.PublisherTeacherName || '后台' }}</span>
                                    <span v-if="activeSemesterItem.Remark" class="publish-card-remark"
                                        :title="activeSemesterItem.Remark">
                                        <i class="el-icon-document"></i> {{ activeSemesterItem.Remark }}
                                    </span>
                                </div>
                                <div class="semester-board-actions">
                                    <el-button size="small" type="primary"
                                        @click="openEditDialog(activeSemesterItem)">编辑</el-button>
                                    <el-button size="small" :disabled="!activeSemesterItem.HasPublished"
                                        @click="openHistoryDialog(activeSemesterItem)">发布记录</el-button>
                                </div>
                            </div>
                            <div class="semester-board-body">
                                <div v-for="star in starLevelsDesc" :key="'board-' + star"
                                    class="star-level-board-block" :class="'star-block-' + star">
                                    <div class="publish-card-label">
                                        <span class="publish-card-title">{{ star }}星班级</span>
                                        <span class="star-rating">
                                            <i v-for="n in star" :key="'card-star-' + star + '-' + n" class="el-icon-star-on active-star"></i>
                                            <i v-for="n in (5 - star)" :key="'card-empty-' + star + '-' + n" class="el-icon-star-off empty-star"></i>
                                        </span>
                                    </div>
                                    <template v-if="getStarGroupClasses(activeSemesterItem, star).length">
                                        <div class="class-tags-preview publish-detail-tags">
                                            <el-tag v-for="c in getListClassPreview(getStarGroupClasses(activeSemesterItem, star))"
                                                :key="c.DepartmentId" size="small"
                                                :type="getStarTagType(star)" class="class-tag-item">
                                                {{ c.DepartmentName }}
                                            </el-tag>
                                        </div>
                                        <span class="view-all-classes-link" role="button" tabindex="0"
                                            @click.stop="openClassesViewDialog(getStarGroupClasses(activeSemesterItem, star), activeSemesterItem.HonorSemesterName + ' · ' + star + '星班级')"
                                            @keyup.enter.stop="openClassesViewDialog(getStarGroupClasses(activeSemesterItem, star), activeSemesterItem.HonorSemesterName + ' · ' + star + '星班级')">
                                            查看全部（{{ getStarGroupClasses(activeSemesterItem, star).length }}）
                                        </span>
                                    </template>
                                    <span v-else class="text-muted">暂无{{ star }}星班级</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </template>
        </section>

        <!-- 查看全部班级 -->
        <el-dialog :title="classesViewTitle" :visible.sync="classesViewVisible" width="560px"
            :close-on-click-modal="true" custom-class="modern-dialog">
            <div class="classes-view-dialog">
                <el-tag v-for="c in classesViewList" :key="c.DepartmentId" size="small"
                    class="class-tag-item">{{ c.DepartmentName }}</el-tag>
            </div>
            <div slot="footer">
                <el-button @click="classesViewVisible = false">关闭</el-button>
            </div>
        </el-dialog>

        <!-- 发布/编辑弹窗 -->
        <el-dialog :visible.sync="editDialogVisible" width="800px"
            :close-on-click-modal="false" @closed="onEditDialogClosed" :custom-class="editIsRowMode ? 'modern-dialog edit-dialog-single' : 'modern-dialog-split'">
            <div slot="title" class="dialog-header-center">
                <span class="dialog-title-main">{{ editDialogTitle }}</span>
                <div v-if="editForm.campusId && editForm.honorSemesterId" class="dialog-title-meta">
                    <span class="meta-badge campus"><i class="el-icon-school"></i> {{ editSelectedCampusName }}</span>
                    <span class="meta-badge semester"><i class="el-icon-date"></i> {{ editSelectedSemesterName }}</span>
                    <span v-if="editSemesterRangeText" class="meta-badge range"><i class="el-icon-time"></i> {{ editSemesterRangeText }}</span>
                </div>
            </div>
            
            <div class="edit-dialog-content">
                <el-form label-width="100px" class="edit-form-area">
                    <el-form-item v-if="!editIsRowMode" label="校区" required>
                        <el-select v-model="editForm.campusId" placeholder="请选择校区" style="width: 100%"
                            :disabled="editIsRowMode" @change="onEditCampusOrSemesterChange">
                            <el-option v-for="c in campusOptions" :key="c.Id" :label="c.Name" :value="c.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="!editIsRowMode" label="荣誉学期" required>
                        <el-select v-model="editForm.honorSemesterId" placeholder="请选择学期" style="width: 100%"
                            :disabled="editIsRowMode" @change="onEditCampusOrSemesterChange">
                            <el-option v-for="s in semesterOptions" :key="s.Id"
                                :label="s.IsCurrent == 1 ? `${s.SemesterName}（当前）` : s.SemesterName" :value="s.Id" />
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="!editIsRowMode && editSemesterRangeText" label="学期区间">
                        <span class="semester-range-text">{{ editSemesterRangeText }}</span>
                    </el-form-item>
                    <el-form-item label="备注说明" class="remark-form-item">
                        <el-input v-model="editForm.remark" maxlength="500" placeholder="请在此输入本次发布的备注说明（选填）..." clearable />
                    </el-form-item>
                </el-form>

                <div class="class-panel">
                    <el-tabs v-model="editActiveStarLevel" type="card" class="star-edit-tabs"
                        @tab-click="onEditStarTabClick">
                        <el-tab-pane v-for="star in starLevelsDesc" :key="'tab-' + star" :name="String(star)">
                            <span slot="label" class="tab-star-label">
                                {{ star }}星
                                <span class="tab-stars">
                                    <i v-for="n in star" :key="'tab-star-' + star + '-' + n" class="el-icon-star-on"></i>
                                </span>
                            </span>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="class-panel-toolbar">
                        <span class="grade-label">年级：</span>
                        <el-select v-model="editSelectedGradeId" placeholder="请选择年级" size="small"
                            class="grade-select" :disabled="!editClassPanelReady || !editGradeGroups.length"
                            @change="onEditGradeChange">
                            <el-option label="全部年级" :value="editGradeAllValue" />
                            <el-option v-for="g in editGradeGroups" :key="g.GradeId" :label="g.GradeName"
                                :value="g.GradeId" />
                        </el-select>
                        <el-input v-model="editClassFilter" placeholder="筛选班级名称" clearable size="small"
                            class="filter-input" :disabled="!editClassPanelReady || editSelectedGradeId === null" />
                        <el-button size="small"
                            :disabled="!editClassPanelReady || editSelectedGradeId === null || !editGradeGroups.length"
                            @click="selectAllInCurrentScope">
                            {{ isEditAllGrades ? '全选' : '全选本年级' }}
                        </el-button>
                        <el-button size="small"
                            :disabled="!editClassPanelReady || editSelectedGradeId === null"
                            @click="clearCurrentScopeSelection">
                            {{ isEditAllGrades ? '清空全部' : '清空本年级' }}
                        </el-button>
                        <el-button v-if="!isEditAllGrades" size="small" :disabled="!editClassPanelReady"
                            @click="clearClassSelection">
                            清空全部
                        </el-button>
                        <span class="selected-count">
                            本星级已选 {{ editCurrentStarSelectedCount }} 个班，共 {{ editTotalSelectedCount }} 个班
                        </span>
                    </div>
                    <div v-if="editClassPanelHint" class="class-panel-hint">
                        <i class="el-icon-warning-outline"></i> {{ editClassPanelHint }}
                    </div>
                    <div v-else class="class-panel-body" v-loading="editClassLoading">
                        <template v-if="isEditAllGrades">
                            <el-checkbox-group v-if="visibleEditGradeGroups.length" v-model="editSelectedClassIds"
                                class="grade-class-all" @change="onEditClassIdsChange">
                                <div v-for="group in visibleEditGradeGroups" :key="group.GradeId"
                                    class="grade-class-block">
                                    <div class="grade-class-block-head">
                                        <span class="grade-block-title">{{ group.GradeName }}</span>
                                        <span class="grade-block-actions">
                                            <el-button type="text" size="mini"
                                                @click.prevent="selectAllInGrade(group)">全选</el-button>
                                            <el-button type="text" size="mini"
                                                @click.prevent="clearGradeSelection(group)">清空</el-button>
                                        </span>
                                    </div>
                                    <div class="grade-class-checkboxes">
                                        <el-checkbox v-for="item in group.Classes" :key="item.DepartmentId"
                                            :label="item.DepartmentId" class="class-checkbox-item"
                                            :disabled="isClassTakenByOtherStar(item.DepartmentId)"
                                            :title="getClassTakenTitle(item.DepartmentId)">
                                            {{ item.DepartmentName }}
                                        </el-checkbox>
                                    </div>
                                </div>
                            </el-checkbox-group>
                        </template>
                        <el-checkbox-group v-else-if="filteredEditSingleGradeClasses.length"
                            v-model="editSelectedClassIds" class="grade-class-checkboxes" @change="onEditClassIdsChange">
                            <el-checkbox v-for="item in filteredEditSingleGradeClasses" :key="item.DepartmentId"
                                :label="item.DepartmentId" class="class-checkbox-item"
                                :disabled="isClassTakenByOtherStar(item.DepartmentId)"
                                :title="getClassTakenTitle(item.DepartmentId)">
                                {{ item.DepartmentName }}
                            </el-checkbox>
                        </el-checkbox-group>
                        <div v-if="!editClassLoading && editGradeGroups.length === 0" class="empty-tip">
                            该校区下暂无行政班
                        </div>
                        <div v-else-if="!editClassLoading && editSelectedGradeId !== null && !hasVisibleEditClasses"
                            class="empty-tip">
                            {{ isEditAllGrades ? '暂无匹配班级' : '当前年级下暂无匹配班级' }}
                        </div>
                    </div>
                </div>
            </div>

            <div slot="footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="editSaveLoading" :disabled="!editCanSave"
                    @click="submitEditSave">保存发布</el-button>
            </div>
        </el-dialog>

        <!-- 发布记录弹窗 -->
        <el-dialog :title="historyDialogTitle" :visible.sync="historyDialogVisible" width="860px"
            :close-on-click-modal="false" @open="loadHistoryList" @closed="onHistoryDialogClosed" custom-class="modern-dialog">
            <el-table :data="historyTableData" v-loading="historyLoading" border stripe size="small"
                style="width: 100%">
                <el-table-column prop="PublishedAt" label="操作时间" width="170" align="center" />
                <el-table-column prop="PublisherTeacherName" label="操作人" width="100" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.PublisherTeacherName || '后台' }}
                    </template>
                </el-table-column>
                <el-table-column label="星级班级" min-width="300">
                    <template slot-scope="scope">
                        <template v-if="hasHistoryStarClasses(scope.row)">
                            <div v-for="star in starLevelsDesc" :key="'hist-' + star"
                                v-show="getHistoryStarClasses(scope.row, star).length"
                                class="history-star-row">
                                <span class="history-star-label">
                                    {{ star }}星
                                    <span class="history-stars">
                                        <i v-for="n in star" :key="'hist-star-' + star + '-' + n" class="el-icon-star-on"></i>
                                    </span>：
                                </span>
                                <el-tag v-for="c in getListClassPreview(getHistoryStarClasses(scope.row, star), 6)"
                                    :key="c.DepartmentId" size="mini" :type="getStarTagType(star)"
                                    class="class-tag-item">
                                    {{ c.DepartmentName }}
                                </el-tag>
                            </div>
                            <span v-if="scope.row.Classes && scope.row.Classes.length" class="view-all-classes-link"
                                role="button" tabindex="0"
                                @click.stop="openClassesViewDialog(scope.row.Classes, '全部星级班级')"
                                @keyup.enter.stop="openClassesViewDialog(scope.row.Classes, '全部星级班级')">
                                查看全部（{{ scope.row.Classes.length }}）
                            </span>
                        </template>
                        <span v-else class="text-muted">（已清空）</span>
                    </template>
                </el-table-column>
                <el-table-column prop="Remark" label="备注" min-width="120" show-overflow-tooltip />
            </el-table>
            <div class="pagination-container">
                <el-pagination layout="total, prev, pager, next" @current-change="handleHistoryPageChange"
                    :current-page="historyPage" :page-size="historyPageSize" :total="historyTotal" />
            </div>
        </el-dialog>
    </section>
</template>

<script>
import { getFiveStarClassPublishAdminSemesterBoard, getFiveStarClassPublishAdminForEdit, getFiveStarClassPublishAdminGradeClassGroups, getFiveStarClassPublishAdminHistory, saveFiveStarClassPublishAdmin, getCampusList, getSemesterList } from '../../api/modules/misc';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';
import DepartmentPane from '../../components/DepartmentPane';

/** 列表/历史表格中班级列最多展示的 tag 数量 */
const LIST_CLASS_PREVIEW_MAX = 12;
/** 编辑弹窗年级下拉：全部年级（与后端 GradeId 0 未分年级区分） */
const EDIT_GRADE_ALL = -1;
/** 星级展示顺序（高→低） */
const STAR_LEVELS_DESC = [5, 4, 3, 2, 1];

/** 创建空的星级班级勾选映射 */
function createEmptyEditStarClassIds() {
    return { 1: [], 2: [], 3: [], 4: [], 5: [] };
}

/** 五星班级发布（PC 后台：列表 + 编辑/记录弹窗）。创建于 2026-05-17 */
export default {
    name: 'FiveStarClassPublishList',
    components: { Toolbar, DepartmentPane },
    data() {
        return {
            schoolDepartmentId: 0,
            treeSelectNode: null,
            filters: {
                campusId: null,
            },
            campusOptions: [],
            semesterOptions: [],
            semesterBoard: {
                campusId: 0,
                campusName: '',
                semesters: [],
            },
            /** 首页看板当前选中的荣誉学期 Id */
            activeSemesterId: null,
            /** 保存后刷新看板时恢复选中的学期 */
            pendingActiveSemesterId: null,
            searchList: [
                {
                    label: '校区',
                    key: 'campusId',
                    type: 'select',
                    clearable: true,
                    options: [],
                },
            ],
            listLoading: false,
            buttonList: [],

            editDialogVisible: false,
            editIsRowMode: false,
            editForm: {
                campusId: null,
                honorSemesterId: null,
                remark: '',
            },
            editGradeGroups: [],
            editGradeAllValue: EDIT_GRADE_ALL,
            editSelectedGradeId: EDIT_GRADE_ALL,
            editClassOptions: [],
            editStarClassIds: createEmptyEditStarClassIds(),
            editActiveStarLevel: '5',
            starLevelsDesc: STAR_LEVELS_DESC,
            editClassFilter: '',
            editSemesterRangeText: '',
            editClassLoading: false,
            editSaveLoading: false,

            classesViewVisible: false,
            classesViewList: [],
            classesViewTitle: '',

            historyDialogVisible: false,
            historyContext: {
                campusId: 0,
                honorSemesterId: 0,
                campusName: '',
                honorSemesterName: '',
            },
            historyTableData: [],
            historyTotal: 0,
            historyPage: 1,
            historyPageSize: 5,
            historyLoading: false,
        };
    },
    computed: {
        semesterBoardSemesters() {
            return this.semesterBoard.semesters || [];
        },
        activeSemesterItem() {
            if (!this.activeSemesterId) return null;
            return this.semesterBoardSemesters.find((s) => s.HonorSemesterId === this.activeSemesterId) || null;
        },
        /** 已加载校区列表但未选择（用户手动清空下拉时） */
        needsCampusSelect() {
            return this.campusOptions.length > 0 && !this.filters.campusId;
        },
        /** 当前学校下无校区数据 */
        campusListEmpty() {
            return !!this.schoolDepartmentId && !this.listLoading && this.campusOptions.length === 0;
        },
        editDialogTitle() {
            return this.editIsRowMode ? '编辑星级班级发布' : '新增星级班级发布';
        },
        /** 当前星级 Tab 的已选班级（与 checkbox-group 双向绑定） */
        editSelectedClassIds: {
            get() {
                const star = Number(this.editActiveStarLevel) || 5;
                return this.editStarClassIds[star] || [];
            },
            set(val) {
                const star = Number(this.editActiveStarLevel) || 5;
                this.$set(this.editStarClassIds, star, val || []);
            },
        },
        editCurrentStarSelectedCount() {
            const star = Number(this.editActiveStarLevel) || 5;
            return (this.editStarClassIds[star] || []).length;
        },
        editTotalSelectedCount() {
            return STAR_LEVELS_DESC.reduce((sum, star) => {
                return sum + ((this.editStarClassIds[star] || []).length);
            }, 0);
        },
        historyDialogTitle() {
            const { campusName, honorSemesterName } = this.historyContext;
            if (campusName || honorSemesterName) {
                return `发布记录 - ${campusName || ''} / ${honorSemesterName || ''}`;
            }
            return '发布记录';
        },
        editCanSave() {
            return this.editForm.campusId > 0 && this.editForm.honorSemesterId > 0;
        },
        /** 校区、荣誉学期均已选，可加载并勾选班级 */
        editClassPanelReady() {
            return !!(this.editForm.campusId > 0 && this.editForm.honorSemesterId > 0);
        },
        /** 未满足条件时在班级区展示提示（优先提示校区） */
        editClassPanelHint() {
            if (!this.editForm.campusId) return '请先选择校区';
            if (!this.editForm.honorSemesterId) return '请先选择荣誉学期';
            return '';
        },
        /** 已选择的校区名称 */
        editSelectedCampusName() {
            if (!this.editForm.campusId) return '';
            const c = this.campusOptions.find((x) => x.Id === this.editForm.campusId);
            return c ? c.Name : (this.semesterBoard.campusName || '');
        },
        /** 已选择的荣誉学期名称 */
        editSelectedSemesterName() {
            if (!this.editForm.honorSemesterId) return '';
            const s = this.semesterOptions.find((x) => x.Id === this.editForm.honorSemesterId);
            return s ? s.SemesterName : '';
        },
        /** 是否选中「全部年级」 */
        isEditAllGrades() {
            return this.editSelectedGradeId === this.editGradeAllValue;
        },
        /** 按年级分组展示班级（全部年级或多年级；支持名称筛选） */
        visibleEditGradeGroups() {
            const key = (this.editClassFilter || '').trim();
            let groups = this.editGradeGroups || [];
            if (!this.isEditAllGrades && this.editSelectedGradeId !== null) {
                groups = groups.filter((g) => g.GradeId === this.editSelectedGradeId);
            }
            return groups
                .map((g) => {
                    const classes = g.Classes || [];
                    const filtered = key
                        ? classes.filter((c) => (c.DepartmentName || '').indexOf(key) >= 0)
                        : classes;
                    return { ...g, Classes: filtered };
                })
                .filter((g) => g.Classes.length > 0);
        },
        /** 选中单个年级时的班级列表（扁平） */
        filteredEditSingleGradeClasses() {
            if (this.isEditAllGrades) return [];
            const list = [];
            this.visibleEditGradeGroups.forEach((g) => {
                (g.Classes || []).forEach((c) => list.push(c));
            });
            return list;
        },
        /** 当前年级/筛选下是否有可展示班级 */
        hasVisibleEditClasses() {
            if (this.isEditAllGrades) return this.visibleEditGradeGroups.length > 0;
            return this.filteredEditSingleGradeClasses.length > 0;
        },
    },
    mounted() {
        const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        // 权限未配按钮时兜底（与 DutyStaff / MoralMallAdmin 一致）
        if (!this.buttonList.some((b) => b.Func === 'handleQuery')) {
            this.buttonList.unshift({ name: '查询', Func: 'handleQuery', id: 999 });
        }
    },
    methods: {
        treeNodeClick(data) {
            const deptId = data.value != null ? data.value : data.Id;
            if (!deptId) return;
            this.treeSelectNode = data || null;
            this.schoolDepartmentId = deptId;
            this.page = 1;
            this.resetToolbarFilters();
            this.campusOptions = [];
            this.semesterOptions = [];
            Promise.all([this.loadCampusOptions(), this.loadSemesterOptions()]).then(() => {
                this.syncToolbarCampusAfterLoad();
                this.loadSemesterBoard();
            });
        },
        /** 切换学校后清空工具栏筛选（校区、学期）及下拉选项 */
        resetToolbarFilters() {
            this.filters.campusId = null;
            this.semesterBoard = { campusId: 0, campusName: '', semesters: [] };
            this.activeSemesterId = null;
            const campusIdx = this.searchList.findIndex((s) => s.key === 'campusId');
            if (campusIdx >= 0) this.$set(this.searchList[campusIdx], 'options', []);
            this.$nextTick(() => {
                const tb = this.$refs.listToolbar;
                if (tb && tb.searchObj) {
                    this.$set(tb.searchObj, 'campusId', null);
                }
            });
        },
        /** 工具栏按钮：由权限子项 Func 映射到同名方法 */
        callFunction(item) {
            if (item && typeof item.search === 'object') {
                this.filters.campusId = item.search.campusId || null;
            }
            if (item && item.Func && typeof this[item.Func] === 'function') {
                this[item.Func].apply(this, item);
            }
        },
        handleQuery() {
            this.loadSemesterBoard();
        },
        resolveActiveCampusId() {
            if (this.filters.campusId) return this.filters.campusId;
            if (this.campusOptions.length > 0) return this.campusOptions[0].Id;
            return null;
        },
        /** 机构树选中的是校区节点且接口未返回列表时，用当前节点作为唯一校区 */
        buildCampusOptionsFromTreeNode() {
            const node = this.treeSelectNode;
            if (!node || !this.schoolDepartmentId) return [];
            const orgType = String(node.DeptOrgType || node.deptOrgType || '').toLowerCase();
            if (orgType === 'campus') {
                return [{
                    Id: this.schoolDepartmentId,
                    Name: node.label || node.Name || node.name || '当前校区',
                }];
            }
            return [];
        },
        /** 加载校区列表后默认选中第一个校区 */
        syncToolbarCampusAfterLoad() {
            if (!this.campusOptions.length) return;
            if (!this.filters.campusId) {
                this.filters.campusId = this.campusOptions[0].Id;
            }
            this.$nextTick(() => {
                const tb = this.$refs.listToolbar;
                if (tb && tb.searchObj) {
                    this.$set(tb.searchObj, 'campusId', this.filters.campusId);
                }
            });
        },
        async loadCampusOptions() {
            if (!this.schoolDepartmentId) {
                this.campusOptions = [];
                return;
            }
            try {
                const res = await getCampusList({ departmentId: this.schoolDepartmentId, page: 1, intPageSize: 999 });
                let list = (res && res.data && res.data.response && res.data.response.data) || [];
                if (!list.length) {
                    list = this.buildCampusOptionsFromTreeNode();
                }
                this.campusOptions = list;
                const opts = list.map((c) => ({ label: c.Name, value: c.Id }));
                const idx = this.searchList.findIndex((s) => s.key === 'campusId');
                if (idx >= 0) this.$set(this.searchList[idx], 'options', opts);
            } catch {
                this.campusOptions = [];
                const idx = this.searchList.findIndex((s) => s.key === 'campusId');
                if (idx >= 0) this.$set(this.searchList[idx], 'options', []);
            }
        },
        /** 学期排序：当前学期置顶，其余按开始日期倒序（与 H5 一致） */
        sortSemesterList(list) {
            if (!list || !list.length) return [];
            return [...list].sort((a, b) => {
                const curA = a.IsCurrent == 1 ? 1 : 0;
                const curB = b.IsCurrent == 1 ? 1 : 0;
                if (curB !== curA) return curB - curA;
                const startA = a.StartDate || '';
                const startB = b.StartDate || '';
                if (startA !== startB) return startB.localeCompare(startA);
                return (b.Id || 0) - (a.Id || 0);
            });
        },
        buildSemesterSelectOptions(list) {
            return this.sortSemesterList(list).map((s) => ({
                label: s.IsCurrent == 1 ? `${s.SemesterName}（当前）` : s.SemesterName,
                value: s.Id,
            }));
        },
        async loadSemesterOptions() {
            if (!this.schoolDepartmentId) {
                this.semesterOptions = [];
                return;
            }
            try {
                const res = await getSemesterList({ departmentId: this.schoolDepartmentId });
                const list = (res && res.response) || [];
                this.semesterOptions = this.sortSemesterList(list);
            } catch {
                this.semesterOptions = [];
            }
        },
        loadSemesterBoard() {
            if (!this.schoolDepartmentId) return;
            const campusId = this.resolveActiveCampusId();
            if (!campusId) {
                this.semesterBoard = { campusId: 0, campusName: '', semesters: [] };
                this.activeSemesterId = null;
                return;
            }
            this.listLoading = true;
            getFiveStarClassPublishAdminSemesterBoard({
                schoolDepartmentId: this.schoolDepartmentId,
                campusId,
            })
                .then((res) => {
                    const data = res.data || res;
                    if (data && data.success && data.response) {
                        const board = data.response;
                        this.semesterBoard = {
                            campusId: board.CampusId || campusId,
                            campusName: board.CampusName || '',
                            semesters: board.Semesters || [],
                        };
                        this.syncActiveSemesterAfterBoardLoad(this.pendingActiveSemesterId);
                        this.pendingActiveSemesterId = null;
                    } else {
                        this.semesterBoard = { campusId, campusName: '', semesters: [] };
                        this.activeSemesterId = null;
                        if (data && data.msg) this.$message.warning(data.msg);
                    }
                })
                .catch(() => {
                    this.semesterBoard = { campusId, campusName: '', semesters: [] };
                    this.activeSemesterId = null;
                    this.$message.error('加载学期看板失败');
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        /** 看板加载后默认选中第一个学期（列表已按当前学期优先排序） */
        syncActiveSemesterAfterBoardLoad(preferHonorSemesterId) {
            const list = this.semesterBoardSemesters;
            if (!list.length) {
                this.activeSemesterId = null;
                return;
            }
            const preferId = preferHonorSemesterId || this.activeSemesterId;
            if (preferId && list.some((s) => s.HonorSemesterId === preferId)) {
                this.activeSemesterId = preferId;
                return;
            }
            this.activeSemesterId = list[0].HonorSemesterId;
        },
        selectBoardSemester(honorSemesterId) {
            this.activeSemesterId = honorSemesterId;
        },

        /** 列表/历史中仅展示前若干班级 tag，避免 line-clamp 出现省略号 */
        getListClassPreview(classes, maxCount) {
            if (!classes || !classes.length) return [];
            const max = maxCount > 0 ? maxCount : LIST_CLASS_PREVIEW_MAX;
            if (classes.length <= max) return classes;
            return classes.slice(0, max);
        },
        getStarTagType(star) {
            if (star >= 5) return 'warning';
            if (star >= 3) return 'success';
            if (star >= 2) return '';
            return 'info';
        },
        getStarGroupClasses(semesterItem, star) {
            if (!semesterItem) return [];
            const groups = semesterItem.StarGroups || [];
            const group = groups.find((g) => g.StarLevel === star);
            if (group && group.Classes && group.Classes.length) return group.Classes;
            if (star === 5 && semesterItem.Classes && semesterItem.Classes.length
                && !groups.length) {
                return semesterItem.Classes;
            }
            return [];
        },
        getSemesterTotalClassCount(semesterItem) {
            if (!semesterItem) return 0;
            if (semesterItem.Classes && semesterItem.Classes.length) return semesterItem.Classes.length;
            return STAR_LEVELS_DESC.reduce((sum, star) => {
                return sum + this.getStarGroupClasses(semesterItem, star).length;
            }, 0);
        },
        getHistoryStarClasses(row, star) {
            if (!row) return [];
            const groups = row.StarGroups || [];
            const group = groups.find((g) => g.StarLevel === star);
            if (group && group.Classes) return group.Classes;
            if (star === 5 && row.Classes) {
                return (row.Classes || []).filter((c) => !c.StarLevel || c.StarLevel === 5);
            }
            return [];
        },
        hasHistoryStarClasses(row) {
            if (!row) return false;
            if (row.Classes && row.Classes.length) return true;
            return STAR_LEVELS_DESC.some((star) => this.getHistoryStarClasses(row, star).length > 0);
        },
        applyStarGroupsToEdit(starGroups) {
            const map = createEmptyEditStarClassIds();
            (starGroups || []).forEach((g) => {
                const star = g.StarLevel;
                if (star >= 1 && star <= 5) {
                    map[star] = [...(g.ClassDepartmentIds || [])];
                }
            });
            this.editStarClassIds = map;
        },
        onEditStarTabClick() {
            this.editClassFilter = '';
        },
        onEditClassIdsChange(newIds) {
            const star = Number(this.editActiveStarLevel) || 5;
            const idSet = new Set(newIds || []);
            STAR_LEVELS_DESC.forEach((s) => {
                if (s === star) return;
                const kept = (this.editStarClassIds[s] || []).filter((id) => !idSet.has(id));
                if (kept.length !== (this.editStarClassIds[s] || []).length) {
                    this.$set(this.editStarClassIds, s, kept);
                }
            });
            this.$set(this.editStarClassIds, star, Array.from(idSet));
        },
        isClassTakenByOtherStar(classId) {
            const star = Number(this.editActiveStarLevel) || 5;
            return STAR_LEVELS_DESC.some((s) => {
                if (s === star) return false;
                return (this.editStarClassIds[s] || []).includes(classId);
            });
        },
        getClassTakenTitle(classId) {
            const star = Number(this.editActiveStarLevel) || 5;
            const taken = STAR_LEVELS_DESC.find((s) => s !== star && (this.editStarClassIds[s] || []).includes(classId));
            return taken ? `已在${taken}星选中` : '';
        },
        buildSaveStarLevelClassIds() {
            const payload = {};
            STAR_LEVELS_DESC.forEach((star) => {
                payload[star] = [...(this.editStarClassIds[star] || [])];
            });
            return payload;
        },

        openClassesViewDialog(classes, title) {
            this.classesViewList = classes || [];
            this.classesViewTitle = title || '班级列表';
            this.classesViewVisible = true;
        },

        openEditDialog(row) {
            if (!this.schoolDepartmentId) {
                this.$message.warning('请先在左侧选择学校');
                return;
            }
            this.editIsRowMode = !!row;
            const campusId = row ? row.CampusId : this.resolveActiveCampusId();
            this.editForm = {
                campusId: campusId || null,
                honorSemesterId: row ? row.HonorSemesterId : null,
                remark: row ? (row.Remark || '') : '',
            };
            if (!this.editForm.campusId) {
                this.$message.warning('请先选择校区');
                return;
            }
            if (!this.editForm.honorSemesterId) {
                this.$message.warning('请从学期块点击编辑');
                return;
            }
            this.editStarClassIds = createEmptyEditStarClassIds();
            this.editActiveStarLevel = '5';
            this.editClassOptions = [];
            this.editGradeGroups = [];
            this.editSelectedGradeId = this.editGradeAllValue;
            this.editClassFilter = '';
            this.editSemesterRangeText = '';
            this.syncEditSemesterRangeText();
            this.editDialogVisible = true;
            if (this.editForm.campusId && this.editForm.honorSemesterId) {
                this.loadEditClassData();
            }
        },
        onEditCampusOrSemesterChange() {
            this.editStarClassIds = createEmptyEditStarClassIds();
            this.editClassOptions = [];
            this.editGradeGroups = [];
            this.editSelectedGradeId = this.editGradeAllValue;
            this.editClassFilter = '';
            this.syncEditSemesterRangeText();
            if (this.editForm.campusId && this.editForm.honorSemesterId) {
                this.loadEditClassData();
            }
        },
        onEditGradeChange() {
            this.editClassFilter = '';
        },
        /** 从学期下拉同步学期区间（未拉取班级前也可展示） */
        syncEditSemesterRangeText() {
            if (!this.editForm.honorSemesterId) {
                this.editSemesterRangeText = '';
                return;
            }
            const s = this.semesterOptions.find((x) => x.Id === this.editForm.honorSemesterId);
            if (s && (s.StartDate || s.EndDate)) {
                this.editSemesterRangeText = `${s.StartDate || ''} ~ ${s.EndDate || ''}`;
            } else {
                this.editSemesterRangeText = '';
            }
        },
        /** 将年级分组扁平化为 editClassOptions（兼容旧逻辑） */
        flattenEditClassOptions() {
            const flat = [];
            (this.editGradeGroups || []).forEach((g) => {
                (g.Classes || []).forEach((c) => flat.push(c));
            });
            this.editClassOptions = flat;
        },
        async loadEditClassData() {
            this.editClassLoading = true;
            try {
                const [groupRes, editRes] = await Promise.all([
                    getFiveStarClassPublishAdminGradeClassGroups({ campusId: this.editForm.campusId }),
                    getFiveStarClassPublishAdminForEdit({
                        campusId: this.editForm.campusId,
                        honorSemesterId: this.editForm.honorSemesterId,
                    }),
                ]);
                const groupData = groupRes.data || groupRes;
                if (groupData && groupData.success) {
                    this.editGradeGroups = groupData.response || [];
                    this.flattenEditClassOptions();
                    this.ensureEditGradeSelected();
                } else {
                    this.editGradeGroups = [];
                    this.editClassOptions = [];
                    this.editSelectedGradeId = this.editGradeAllValue;
                }
                const editData = editRes.data || editRes;
                if (editData && editData.success && editData.response) {
                    const dto = editData.response;
                    if (dto.StarGroups && dto.StarGroups.length) {
                        this.applyStarGroupsToEdit(dto.StarGroups);
                    } else {
                        const map = createEmptyEditStarClassIds();
                        map[5] = [...(dto.ClassDepartmentIds || [])];
                        this.editStarClassIds = map;
                    }
                    if (!this.editIsRowMode) {
                        this.editForm.remark = dto.Remark || this.editForm.remark;
                    }
                    if (dto.HonorSemesterStartDate || dto.HonorSemesterEndDate) {
                        this.editSemesterRangeText = `${dto.HonorSemesterStartDate || ''} ~ ${dto.HonorSemesterEndDate || ''}`;
                    }
                }
            } catch {
                this.$message.error('加载班级数据失败');
            } finally {
                this.editClassLoading = false;
            }
        },
        /** 默认选中「全部年级」；若当前年级不存在则回退 */
        ensureEditGradeSelected() {
            if (this.editSelectedGradeId === this.editGradeAllValue) return;
            if (this.editSelectedGradeId !== null) {
                const exists = this.editGradeGroups.some((g) => g.GradeId === this.editSelectedGradeId);
                if (exists) return;
            }
            this.editSelectedGradeId = this.editGradeAllValue;
        },
        /** 全选当前范围（全部年级或当前年级，含筛选） */
        selectAllInCurrentScope() {
            if (!this.editClassPanelReady) {
                this.$message.warning('请先选择校区和荣誉学期');
                return;
            }
            if (this.editSelectedGradeId === null) {
                this.$message.warning('请先选择年级');
                return;
            }
            const ids = this.isEditAllGrades
                ? this.visibleEditGradeGroups.flatMap((g) => (g.Classes || []).map((c) => c.DepartmentId))
                : this.filteredEditSingleGradeClasses.map((c) => c.DepartmentId);
            const merged = Array.from(new Set([...this.editSelectedClassIds, ...ids]));
            this.onEditClassIdsChange(merged);
        },
        /** 清空当前范围（全部年级或当前年级） */
        clearCurrentScopeSelection() {
            if (!this.editClassPanelReady || this.editSelectedGradeId === null) return;
            if (this.isEditAllGrades) {
                this.clearClassSelection();
                return;
            }
            const scopeIds = new Set(this.filteredEditSingleGradeClasses.map((c) => c.DepartmentId));
            this.onEditClassIdsChange(this.editSelectedClassIds.filter((id) => !scopeIds.has(id)));
        },
        /** 全选指定年级下的班级（含筛选） */
        selectAllInGrade(group) {
            if (!group || !group.Classes || !group.Classes.length) return;
            const ids = group.Classes
                .map((c) => c.DepartmentId)
                .filter((id) => !this.isClassTakenByOtherStar(id));
            const merged = Array.from(new Set([...this.editSelectedClassIds, ...ids]));
            this.onEditClassIdsChange(merged);
        },
        /** 清空指定年级下的已选班级 */
        clearGradeSelection(group) {
            if (!group || !group.Classes) return;
            const gradeIds = new Set(group.Classes.map((c) => c.DepartmentId));
            this.onEditClassIdsChange(this.editSelectedClassIds.filter((id) => !gradeIds.has(id)));
        },
        clearClassSelection() {
            if (!this.editClassPanelReady) return;
            this.onEditClassIdsChange([]);
        },
        submitEditSave() {
            if (!this.editForm.campusId) {
                this.$message.warning('请先选择校区');
                return;
            }
            if (!this.editForm.honorSemesterId) {
                this.$message.warning('请先选择荣誉学期');
                return;
            }
            this.editSaveLoading = true;
            saveFiveStarClassPublishAdmin({
                campusId: this.editForm.campusId,
                honorSemesterId: this.editForm.honorSemesterId,
                starLevelClassIds: this.buildSaveStarLevelClassIds(),
                remark: this.editForm.remark,
            })
                .then((res) => {
                    const data = res.data || res;
                    if (data && data.success) {
                        this.$message.success('保存成功');
                        this.editDialogVisible = false;
                        this.pendingActiveSemesterId = this.editForm.honorSemesterId;
                        this.loadSemesterBoard();
                    } else {
                        this.$message.error((data && data.msg) || '保存失败');
                    }
                })
                .finally(() => {
                    this.editSaveLoading = false;
                });
        },
        onEditDialogClosed() {
            this.editIsRowMode = false;
            this.editClassOptions = [];
            this.editGradeGroups = [];
            this.editSelectedGradeId = this.editGradeAllValue;
            this.editStarClassIds = createEmptyEditStarClassIds();
            this.editActiveStarLevel = '5';
            this.editClassFilter = '';
            this.editSemesterRangeText = '';
        },

        openHistoryDialog(row) {
            this.historyContext = {
                campusId: row.CampusId,
                honorSemesterId: row.HonorSemesterId,
                campusName: this.semesterBoard.campusName || '',
                honorSemesterName: row.HonorSemesterName || '',
            };
            this.historyPage = 1;
            this.historyTableData = [];
            this.historyDialogVisible = true;
        },
        loadHistoryList() {
            const { campusId, honorSemesterId } = this.historyContext;
            if (!campusId || !honorSemesterId) return;
            this.historyLoading = true;
            getFiveStarClassPublishAdminHistory({
                campusId,
                honorSemesterId,
                page: this.historyPage,
                pageSize: this.historyPageSize,
            })
                .then((res) => {
                    const data = res.data || res;
                    if (data && data.success && data.response) {
                        this.historyTableData = data.response.data || [];
                        this.historyTotal = data.response.dataCount || 0;
                    } else {
                        this.historyTableData = [];
                        this.historyTotal = 0;
                    }
                })
                .finally(() => {
                    this.historyLoading = false;
                });
        },
        handleHistoryPageChange(val) {
            this.historyPage = val;
            this.loadHistoryList();
        },
        onHistoryDialogClosed() {
            this.historyTableData = [];
            this.historyTotal = 0;
            this.historyPage = 1;
        },
    },
};
</script>

<style scoped>
/* 提示在左侧选择学校的样式 */
.no-dept-tip {
    margin-top: 40px;
    text-align: center;
    color: #94a3b8;
    font-size: 14px;
}

/* 学期日期范围 */
.semester-range {
    margin: 6px 0 0;
    font-size: 13px;
    color: #64748b;
    line-height: 1.4;
}

/* 页面根容器防溢出 */
.five-star-publish-page {
    overflow-x: hidden;
}

/* 列表主要内容容器 */
.publish-page-content {
    width: 100%;
    min-width: 0;
}

/* 工具栏全宽样式覆盖 */
.publish-page-content >>> .toolbar.el-col {
    width: 100%;
    float: none;
}

/* 列表外层包装器 */
.publish-list-wrap {
    width: 100%;
    min-width: 0;
    margin-top: 16px;
    min-height: 200px;
    clear: both;
}

/* 暂无学期配置空状态样式 */
.publish-empty {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 280px;
    width: 100%;
}
.publish-empty >>> .el-empty {
    width: 100%;
}
.publish-empty >>> .el-empty__description {
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.5;
    white-space: normal;
}

/* 顶部校区标题，增加左侧修饰条，使其更有层次 */
.board-campus-title {
    margin: 16px 0 8px;
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
}
.board-campus-title::before {
    content: "";
    display: inline-block;
    width: 4px;
    height: 16px;
    background: #3b82f6;
    border-radius: 2px;
    margin-right: 8px;
}

/* 校区未选择提示样式 */
.campus-select-tip {
    padding: 48px 16px;
    text-align: center;
    color: #94a3b8;
    font-size: 14px;
}
.campus-select-tip i {
    margin-right: 6px;
}

/* 看板整体容器：高雅细边框 + 微弱阴影，现代圆角 */
.semester-board-layout {
    display: flex;
    align-items: stretch;
    gap: 0;
    min-height: 380px;
    width: 100%;
    min-width: 0;
    border: 1px solid rgba(226, 232, 240, 0.8);
    border-radius: 12px;
    background: #fff;
    overflow: hidden;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.02), 0 8px 10px -6px rgba(0, 0, 0, 0.02);
}

/* 左侧学期导航栏：浅灰蓝底色，细滚动条 */
.semester-nav {
    width: 220px;
    flex-shrink: 0;
    border-right: 1px solid #f1f5f9;
    background: #f8fafc;
    max-height: min(70vh, 640px);
    overflow-y: auto;
}
.semester-nav::-webkit-scrollbar {
    width: 5px;
}
.semester-nav::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}
.semester-nav::-webkit-scrollbar-track {
    background: transparent;
}

/* 导航单项：现代卡片式圆角布局，高响应性过渡 */
.semester-nav-item {
    padding: 14px 16px;
    margin: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    background: transparent;
}
.semester-nav-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 15%;
    height: 70%;
    width: 3px;
    background: transparent;
    border-radius: 2px;
    transition: all 0.3s ease;
}
.semester-nav-item:hover {
    background: #f1f5f9;
    transform: translateX(4px);
}
.semester-nav-item.is-active {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.08) 0%, rgba(99, 102, 241, 0.04) 100%);
}
.semester-nav-item.is-active::before {
    background: #3b82f6;
}
.semester-nav-item.is-active .semester-nav-name {
    color: #2563eb;
}

/* 侧边导航学期名称 */
.semester-nav-title {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}
.semester-nav-name {
    font-size: 14px;
    font-weight: 600;
    color: #1e293b;
    transition: color 0.3s ease;
}
.semester-nav-range {
    margin: 6px 0 0;
    font-size: 11px;
    color: #64748b;
    line-height: 1.4;
}
.semester-nav-meta {
    display: inline-block;
    margin-top: 6px;
    font-size: 11px;
    color: #94a3b8;
}

/* 右侧学期详情面板，美化滚动条 */
.semester-board-detail {
    flex: 1;
    min-width: 0;
    padding: 20px 24px;
    max-height: min(70vh, 640px);
    overflow-y: auto;
}
.semester-board-detail::-webkit-scrollbar {
    width: 5px;
}
.semester-board-detail::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}
.semester-board-detail::-webkit-scrollbar-track {
    background: transparent;
}

/* 右侧详情头部区域 */
.semester-board-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    margin-bottom: 8px;
}
.semester-board-head-main {
    flex: 1;
    min-width: 200px;
}
.semester-board-head-main .semester-name {
    font-size: 18px;
    font-weight: 600;
    color: #0f172a;
    margin-right: 8px;
}
.current-semester-tag {
    vertical-align: middle;
    border-radius: 4px;
}
.semester-board-actions {
    flex-shrink: 0;
}
.semester-board-actions >>> .el-button {
    border-radius: 6px;
    transition: all 0.2s ease;
}
.semester-board-actions >>> .el-button--primary {
    box-shadow: 0 4px 10px rgba(59, 130, 246, 0.15);
}
.semester-board-actions >>> .el-button--primary:hover {
    box-shadow: 0 6px 14px rgba(59, 130, 246, 0.25);
    transform: translateY(-1px);
}

/* 右侧看板主体部分，增加顶边虚线 */
.semester-board-body {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px dashed #e2e8f0;
}
.semester-name {
    font-size: 18px;
    font-weight: 600;
    color: #0f172a;
}
.campus-tag {
    max-width: 100%;
}

/* 星级板级容器卡片：不同星级对应专属渐变背景与色块标识 */
.star-level-board-block {
    margin-bottom: 16px;
    padding: 16px 20px;
    border-radius: 8px;
    border-left: 4px solid transparent;
    transition: all 0.3s ease;
}
.star-level-board-block:last-child {
    margin-bottom: 0;
}

/* 5星级专属：琥珀金 */
.star-block-5 {
    background: linear-gradient(90deg, rgba(245, 158, 11, 0.05) 0%, rgba(251, 191, 36, 0.01) 100%);
    border: 1px solid rgba(245, 158, 11, 0.08);
    border-left: 4px solid #f59e0b;
}
/* 4星级专属：活力橙 */
.star-block-4 {
    background: linear-gradient(90deg, rgba(249, 115, 22, 0.05) 0%, rgba(251, 146, 60, 0.01) 100%);
    border: 1px solid rgba(249, 115, 22, 0.08);
    border-left: 4px solid #f97316;
}
/* 3星级专属：清新绿 */
.star-block-3 {
    background: linear-gradient(90deg, rgba(16, 185, 129, 0.05) 0%, rgba(52, 211, 153, 0.01) 100%);
    border: 1px solid rgba(16, 185, 129, 0.08);
    border-left: 4px solid #10b981;
}
/* 2星级专属：深邃蓝 */
.star-block-2 {
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.05) 0%, rgba(96, 165, 250, 0.01) 100%);
    border: 1px solid rgba(59, 130, 246, 0.08);
    border-left: 4px solid #3b82f6;
}
/* 1星级专属：雅致灰 */
.star-block-1 {
    background: linear-gradient(90deg, rgba(107, 114, 128, 0.05) 0%, rgba(156, 163, 175, 0.01) 100%);
    border: 1px solid rgba(107, 114, 128, 0.08);
    border-left: 4px solid #6b7280;
}

/* 标签编辑栏选项卡：重构为极致轻盈的 iOS 胶囊样式 */
.star-edit-tabs {
    margin-bottom: 16px;
}
.star-edit-tabs >>> .el-tabs__nav-wrap {
    background: #f1f5f9;
    padding: 4px;
    border-radius: 8px;
    display: inline-block;
}
.star-edit-tabs >>> .el-tabs__nav {
    border: none !important;
}
.star-edit-tabs >>> .el-tabs__item {
    border: none !important;
    border-radius: 6px;
    height: 32px;
    line-height: 32px;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    color: #64748b;
    font-weight: 500;
    font-size: 13px;
    padding: 0 16px !important;
}
.star-edit-tabs >>> .el-tabs__item:hover {
    color: #1e293b;
}
.star-edit-tabs >>> .el-tabs__item.is-active {
    background: #ffffff;
    color: #3b82f6;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
}
.star-edit-tabs >>> .el-tabs__header {
    border: none !important;
    margin-bottom: 12px;
}

/* 历史记录星级行 */
.history-star-row {
    margin-bottom: 8px;
    line-height: 1.6;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.history-star-label {
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    margin-right: 8px;
    min-width: 45px;
}

/* 各星级标题文本：使用 Flex 两端对齐，将星星评分推至最右侧 */
.publish-card-label {
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* 卡片内部标签总高度 */
.publish-card-tags {
    max-height: 72px;
}

/* 看板头部及底部发布元信息容器：胶囊式小标签聚合 */
.semester-board-head-meta,
.publish-card-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 12px;
    font-size: 12px;
    color: #64748b;
}
.semester-board-head-meta {
    margin-top: 6px;
    margin-left: 20px;
    flex: 1; /* 占据中间剩余空间 */
    justify-content: flex-start;
}
.publish-card-meta {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px dashed #e2e8f0;
}
.semester-board-head-meta > span,
.publish-card-meta > span {
    background: #f1f5f9;
    padding: 4px 10px;
    border-radius: 20px;
    display: inline-flex;
    align-items: center;
}
.semester-board-head-meta i,
.publish-card-meta i {
    margin-right: 6px;
    color: #94a3b8;
}
.publish-card-remark {
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* 荣誉学期范围文本：美化为蓝色胶囊指示牌 */
.semester-range-text {
    display: inline-flex;
    align-items: center;
    background: #eff6ff;
    color: #1e40af;
    padding: 4px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #bfdbfe;
}

/* 静默浅色文本 */
.text-muted {
    color: #94a3b8;
}

/* 分页组件布局 */
.pagination-container {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
    clear: both;
}

/* 看板中班级 Tag 包裹栏，限制高度防溢出 */
.class-tags-preview {
    display: flex;
    flex-wrap: wrap;
    max-height: 64px;
    overflow-y: auto;
    gap: 6px;
    margin-bottom: 8px;
}
.class-tags-preview::-webkit-scrollbar {
    width: 3px;
}
.class-tags-preview::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
}

/* 统一重写 ElementUI 标签为高雅圆润的现代胶囊卡片 */
.publish-detail-tags >>> .el-tag,
.classes-view-dialog >>> .el-tag,
.history-star-row >>> .el-tag {
    border-radius: 12px;
    border: 1px solid transparent;
    font-weight: 500;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    margin: 2px 4px 2px 0;
}
.publish-detail-tags >>> .el-tag:hover,
.classes-view-dialog >>> .el-tag:hover,
.history-star-row >>> .el-tag:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
}

/* 查看全部班级链接 */
.view-all-classes-link {
    display: inline-block;
    margin-top: 4px;
    font-size: 12px;
    color: #3b82f6;
    font-weight: 500;
    cursor: pointer;
    line-height: 1.5;
    user-select: none;
    transition: color 0.2s ease;
}
.view-all-classes-link:hover {
    color: #1d4ed8;
    text-decoration: none;
}
.view-all-classes-link:focus {
    outline: none;
}

/* 班级全部展示弹窗，微美化滚动条 */
.classes-view-dialog {
    max-height: 350px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px;
}
.classes-view-dialog::-webkit-scrollbar {
    width: 5px;
}
.classes-view-dialog::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

/* 原 .grade-class-row 样式已合并至 .class-panel-toolbar */

/* 班级展示主面板：消除顶部分隔线，自适应左右 Flex 列 */
.class-panel {
    flex: 1;
    min-width: 0;
    margin-top: 0;
    padding-top: 0;
    border-top: none;
    max-height: 480px; /* 适度拉高右侧班级区的高度上限 */
    overflow-y: auto;
    padding-right: 16px; /* 增加右内边距，使右侧班级卡片和滚动条/边缘产生舒适的呼吸感间距 */
}
.class-panel::-webkit-scrollbar {
    width: 5px;
}
.class-panel::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.grade-class-all {
    display: block;
    width: 100%;
}
.grade-class-block {
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px dashed #e2e8f0;
}
.grade-class-block:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

/* 年级模块标题头部美化 */
.grade-class-block-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
}
.grade-block-title {
    font-size: 14px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
}
.grade-block-title::before {
    content: "";
    display: inline-block;
    width: 3px;
    height: 12px;
    background: #64748b;
    border-radius: 2px;
    margin-right: 6px;
}
.grade-block-actions .el-button--text {
    color: #64748b;
    font-weight: 500;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 4px;
    transition: all 0.2s ease;
}
.grade-block-actions .el-button--text:hover {
    color: #3b82f6;
    background: rgba(59, 130, 246, 0.05);
}

/* 班级复选框网格 */
.grade-class-checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

/* 班级展示主面板操作栏：一行流水平垂直完美居中对齐 */
.class-panel-toolbar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
    margin-bottom: 16px;
    width: 100%;
}
.class-panel-toolbar .grade-label {
    color: #475569;
    font-size: 14px;
    font-weight: 500;
}
.class-panel-toolbar .grade-select {
    width: 130px;
    flex-shrink: 0;
}
.class-panel-toolbar .filter-input {
    width: 170px;
    flex-shrink: 0;
    margin-right: 4px;
}
.class-panel-toolbar >>> .el-button {
    border-radius: 6px;
    border: 1px solid #cbd5e1;
    color: #475569;
    background: #ffffff;
    transition: all 0.2s ease;
}
.class-panel-toolbar >>> .el-button:hover:not(.is-disabled) {
    color: #3b82f6;
    border-color: #3b82f6;
    background: #eff6ff;
}

/* 选中计数胶囊小标签，推至行尾对齐 */
.selected-count {
    margin-left: auto;
    color: #1e40af;
    font-weight: 600;
    background: #eff6ff;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 12px;
    border: 1px solid #bfdbfe;
}

/* 重点重构：班级 Checkbox 转换为无原始框的现代按压式微卡片 */
.class-checkbox-item {
    width: 130px;
    height: 38px;
    justify-content: center;
    margin: 0 !important;
    padding: 0 8px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: #f8fafc;
    box-sizing: border-box;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    display: inline-flex;
    align-items: center;
    position: relative;
    overflow: hidden;
}
.class-checkbox-item:hover:not(.is-disabled) {
    border-color: #cbd5e1;
    background: #f1f5f9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
/* 选中态：卡片背景浅蓝、蓝色边框，并包含右上角精美对勾三角形 */
.class-checkbox-item.is-checked {
    border-color: #3b82f6;
    background: #eff6ff;
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.08);
}
.class-checkbox-item.is-checked::after {
    content: "✓";
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
    height: 16px;
    background: #3b82f6;
    color: #ffffff;
    font-size: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom-left-radius: 6px;
}
/* 禁用态：虚线边框，半透明灰色淡化 */
.class-checkbox-item.is-disabled {
    background: #f1f5f9;
    border-color: #cbd5e1;
    border-style: dashed;
    opacity: 0.4;
    cursor: not-allowed;
}

/* 隐藏原本突兀的原生复选小方框 */
.class-checkbox-item >>> .el-checkbox__input {
    display: none;
}
.class-checkbox-item >>> .el-checkbox__label {
    font-size: 13px;
    color: #475569 !important;
    padding-left: 0 !important;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
}
.class-checkbox-item.is-checked >>> .el-checkbox__label {
    color: #1d4ed8 !important;
    font-weight: 600;
}

/* 空状态说明 */
.empty-tip {
    color: #94a3b8;
    padding: 12px 0;
    text-align: center;
}

/* 提示警示框样式 */
.class-panel-hint {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 140px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    text-align: center;
    color: #d97706;
    background: #fffbeb;
    border: 1px solid #fde68a;
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
}
.class-panel-hint i {
    margin-right: 6px;
    vertical-align: middle;
    font-size: 16px;
}

.class-panel-body {
    min-height: 140px;
}

</style>

<style>
/* 现代 Dialog 通用样式（普通上下排列，适用于发布记录及班级总览） */
.modern-dialog {
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
}
.modern-dialog .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f1f5f9;
}
.modern-dialog .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
}
.modern-dialog .el-dialog__body {
    padding: 24px !important;
    display: block !important; /* 显式声明，阻断任何可能的继承，恢复普通上下排列 */
}
.modern-dialog .el-dialog__footer {
    padding: 16px 24px 20px;
    border-top: 1px solid #f1f5f9;
    background: #f8fafc;
}

/* 现代 Dialog 左右分栏版（专为发布/编辑弹窗设计） */
.modern-dialog-split {
    width: 1020px !important; /* 设定为 1020px 宽，为左右分栏提供充裕横向空间 */
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    border: 1px solid rgba(226, 232, 240, 0.8) !important;
}
.modern-dialog-split .el-dialog__header {
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f1f5f9;
}
.modern-dialog-split .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #1e293b;
}
.modern-dialog-split .el-dialog__body {
    padding: 24px !important;
    display: block !important; /* 原生 body 为普通容器，只做 padding 用 */
}
/* 内部 Flex 布局容器 */
.modern-dialog-split .edit-dialog-content {
    display: flex !important;
    align-items: stretch;
    gap: 28px;
    width: 100%;
}
/* 左侧表单区域收窄，并添加右侧边框分隔线 */
.modern-dialog-split .edit-form-area {
    width: 260px;
    flex-shrink: 0;
    border-right: 1px solid #f1f5f9;
    padding-right: 28px;
}
/* 覆盖左侧表单的 Label 及排列方式为上下排版，适应较窄的列宽 */
.modern-dialog-split .edit-form-area .el-form-item {
    margin-bottom: 16px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
}
.modern-dialog-split .edit-form-area .el-form-item__label {
    text-align: left;
    width: auto !important; /* 覆盖 label-width 带来的 100px 固定宽度限制 */
    padding: 0 0 6px 0;
    line-height: 1.5;
    font-weight: 600;
    color: #475569;
}
.modern-dialog-split .edit-form-area .el-form-item__content {
    margin-left: 0 !important; /* 覆盖表单原生带来的 100px 左外边距 */
}
.modern-dialog-split .el-input__inner,
.modern-dialog-split .el-textarea__inner {
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background-color: #f8fafc;
    transition: all 0.2s ease;
}
.modern-dialog-split .el-input__inner:focus,
.modern-dialog-split .el-textarea__inner:focus {
    border-color: #3b82f6;
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.modern-dialog-split .el-dialog__footer {
    padding: 16px 24px 20px;
    border-top: 1px solid #f1f5f9;
    background: #f8fafc;
}

/* 现代 Dialog 单栏版（专为编辑状态的弹窗设计） */
.edit-dialog-single .edit-dialog-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}
.edit-dialog-single .class-panel {
    order: 1; /* 班级选择面板在前 */
    width: 100%;
}
.edit-dialog-single .edit-form-area {
    order: 2; /* 备注表单在后 */
    width: 100%;
    border-right: none !important;
    padding-right: 0 !important;
    border-top: 1px dashed #e2e8f0; /* 与上方用优雅虚线分割 */
    padding-top: 16px;
}
.edit-dialog-single .edit-form-area .el-form-item {
    display: flex;
    align-items: center;
    margin-bottom: 0; /* 底部单表单项，无需下外边距 */
}
.edit-dialog-single .edit-form-area .el-form-item__label {
    width: 80px !important;
    text-align: left;
    font-weight: 600;
    color: #475569;
    padding: 0;
    line-height: 1.5;
}
.edit-dialog-single .edit-form-area .el-form-item__content {
    flex: 1;
    margin-left: 0 !important;
}
.edit-dialog-single .el-input__inner {
    border-radius: 8px;
    border: 1px solid #cbd5e1;
    background-color: #f8fafc;
    transition: all 0.2s ease;
}
.edit-dialog-single .el-input__inner:focus {
    border-color: #3b82f6;
    background-color: #ffffff;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 弹窗头部居中化与元信息胶囊样式 */
.dialog-header-center {
    text-align: center;
    padding-right: 32px; /* 留出关闭 X 按钮的位置 */
}
.dialog-title-main {
    font-size: 18px;
    font-weight: 600;
    color: #1e293b;
    display: block;
    margin-bottom: 8px;
}
.dialog-title-meta {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 4px;
}
.dialog-title-meta .meta-badge {
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 1.4;
}
.dialog-title-meta .meta-badge i {
    margin-right: 4px;
}
/* 不同信息小胶囊专属配色 */
.dialog-title-meta .meta-badge.campus {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #dbeafe;
}
.dialog-title-meta .meta-badge.semester {
    background: #f0fdf4;
    color: #15803d;
    border: 1px solid #dcfce7;
}
.dialog-title-meta .meta-badge.range {
    background: #fffbeb;
    color: #b45309;
    border: 1px solid #fef3c7;
}


</style>

<style scoped>

/* 看板星级评分红色星星 */
.star-rating {
    margin-left: 8px;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    vertical-align: middle;
}
.star-rating .active-star {
    color: #ef4444; /* 红色星星 */
    font-size: 14px;
}
.star-rating .empty-star {
    color: #cbd5e1; /* 空心灰色星星 */
    font-size: 14px;
}

/* 弹窗 Tab 页的红色小星星 */
.tab-star-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}
.tab-stars {
    display: inline-flex;
    align-items: center;
    gap: 1px;
    color: #ef4444;
    font-size: 11px;
}

/* 历史记录里的红色小星星 */
.history-stars {
    display: inline-flex;
    align-items: center;
    gap: 1px;
    color: #ef4444;
    font-size: 11px;
    vertical-align: middle;
    margin-left: 2px;
}
</style>
